export default "__VITE_ASSET__af661daa__"